export default "__VITE_ASSET__AXN0G1Eh__"